import { render } from "./add_hod.vue?vue&type=template&id=058ce284"
import script from "./add_hod.vue?vue&type=script&lang=js"
export * from "./add_hod.vue?vue&type=script&lang=js"

import "./add_hod.vue?vue&type=style&index=0&id=058ce284&lang=css"

import exportComponent from "/var/www/kutchinaasp-uat.kutchina.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__